import { jsxs as V, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as l } from "./index.es2447.js";
function e({ size: H = l }) {
  return /* @__PURE__ */ V(
    "svg",
    {
      width: H,
      height: H,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M39 17H17V37H22V32H27.1867C27.3578 32 27.5171 31.9124 27.6088 31.7679L29.5124 28.7683L29.5183 28.7774L31.5183 31.7774C31.611 31.9164 31.7671 32 31.9343 32H34V37H39V17ZM29.0905 28H29.9343C29.7491 28 29.5985 28.0958 29.5124 28.2316C29.4262 28.0957 29.2754 28 29.0905 28Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M18.5 23.5C16.8463 23.5 15.5 22.1806 15.5 20.56V16.5H40.5V20.56C40.5 22.1806 39.1537 23.5 37.5 23.5C35.8463 23.5 34.5 22.1806 34.5 20.56V19.56C34.5 21.1806 33.0415 22.5 31.25 22.5C29.4585 22.5 28 21.1806 28 19.56C28 21.1806 26.5415 22.5 24.75 22.5C22.9585 22.5 21.5 21.1806 21.5 19.56V20.56C21.5 22.1806 20.1537 23.5 18.5 23.5Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M29.0905 28H29.9343C29.7491 28 29.5985 28.0958 29.5124 28.2316C29.4262 28.0957 29.2754 28 29.0905 28Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M22 39.5V32H27.1867C27.3578 32 27.5171 31.9124 27.6088 31.7679L29.5124 28.7683L29.5183 28.7774L31.5183 31.7774C31.611 31.9164 31.7672 32 31.9343 32H34V39.5C34 39.7761 33.7761 40 33.5 40H22.5C22.2239 40 22 39.7761 22 39.5Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 20.56V16H41V20.56C41 21.9347 40.1784 23.1157 39 23.6674V37H34V39.5C34 39.7761 33.7761 40 33.5 40H22.5C22.2239 40 22 39.7761 22 39.5V37H17V23.6674C15.8216 23.1157 15 21.9347 15 20.56ZM18 23.9649V36H22V32H19.9095C19.5152 32 19.2761 31.565 19.4873 31.2321L21.3912 28.2321C21.4829 28.0876 21.6422 28 21.8133 28H34.0658C34.233 28 34.3891 28.0836 34.4818 28.2226L36.4818 31.2227C36.7034 31.5549 36.4652 32 36.0658 32H34V36H38V23.9649C37.8366 23.988 37.6696 24 37.5 24C35.9792 24 34.6719 23.038 34.1939 21.6908C33.4984 22.4949 32.4229 23 31.25 23C29.8877 23 28.6568 22.3186 28 21.2786C27.3432 22.3186 26.1123 23 24.75 23C23.5771 23 22.5016 22.4949 21.8061 21.6908C21.3281 23.038 20.0208 24 18.5 24C18.3304 24 18.1634 23.988 18 23.9649ZM22 17H27.5V19.56C27.5 20.8585 26.3137 22 24.75 22C23.1863 22 22 20.8585 22 19.56V17ZM28.5 19.56V17H34V19.56C34 20.8585 32.8137 22 31.25 22C29.6863 22 28.5 20.8585 28.5 19.56ZM35 20.56V17H40V20.56C40 21.895 38.8871 23 37.5 23C36.1129 23 35 21.895 35 20.56ZM21 20.56V17H16V20.56C16 21.895 17.1129 23 18.5 23C19.8871 23 21 21.895 21 20.56ZM20.819 31L22.0882 29H28.181L26.9118 31H20.819ZM33 32H31.9343C31.7672 32 31.611 31.9164 31.5183 31.7774L30 29.4999V39H33V32ZM27.6088 31.7679L29 29.5758V39H23V32H27.1867C27.3578 32 27.5171 31.9124 27.6088 31.7679ZM35.1315 31L33.7982 29H30.8686L32.2019 31H35.1315Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
e.__tags = [];
export {
  e as MetricStoreSupplyIcon
};
//# sourceMappingURL=index.es426.js.map
